export default __webpack_public_path__ + "static/media/Animale_mob_banner_1.b4352571.png";